import { render, staticRenderFns } from "./AlertDiscount.vue?vue&type=template&id=1e8b01f8&scoped=true"
import script from "./AlertDiscount.vue?vue&type=script&lang=ts"
export * from "./AlertDiscount.vue?vue&type=script&lang=ts"
import style0 from "./AlertDiscount.vue?vue&type=style&index=0&id=1e8b01f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b01f8",
  null
  
)

export default component.exports